import { IObjectsHasTags, ITags } from '@llws/lift-entity-interfaces';
import { convertQueryCommandToQueryString, Equal, In, IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { adminRequest } from '@/shared/request-configs/admin-request';
import {
  IApiResponse, IMetaResponse,
} from '@/shared';

/**
 * Fetches Tags by Model & Object Ids <br>
 * API Endpoint - `/website-api/objects_has_tags${filters}` <br> via {@link adminRequest.get}
 * @param {string} model - model
 * @param {(string | number)} objectId - object id
 * @param {boolean} [returnAsTags] - optional param to return as ITags[]
 */
export const getByModelAndObjectId = async (
  model: string,
  objectId: string | number,
  returnAsTags?: boolean,
): Promise<IApiResponse<IObjectsHasTags[] | ITags[], IMetaResponse>> => {
  const filters: IQueryCommandOptions = {
    relations: [{ path: 'tag', alias: 'tag' }],
    where: [
      In('model', model.split(',')),
      Equal('objectId', objectId),
    ],
    limit: 9999,
  };

  const response: IApiResponse<IObjectsHasTags[], IMetaResponse> = await adminRequest.get(`/website-api/objects_has_tags${convertQueryCommandToQueryString(filters)}`);

  if (returnAsTags) {
    return { data: Array.from((response.data || []), (v: IObjectsHasTags) => v.tag) as ITags[] };
  }

  return response;
};

/**
 * Fetches Tags By ClientID <br>
 * API Endpoint - `/website-api/tags?clientId=${clientId}` <br> via {@link adminRequest.get}
 * @param {(string | number)} clientId - id of the client
 */
export const getTags = async (
  clientId: string | number,
) => {
  const filters: IQueryCommandOptions = {
    where: [
      Equal('clientId', clientId),
    ],
    limit: 9999,
  };
  const response = await adminRequest.get(`/website-api/tags${convertQueryCommandToQueryString(filters)}`);

  return response;
};

export default {
  getByModelAndObjectId,
  getTags,
};
